// GET SUMMARY
export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS'
export const GET_SUMMARY_FAIL = 'GET_SUMMARY_FAIL'
export const GET_SUMMARY = 'GET_SUMMARY'
export const RESET_SUMMARY_LOADERS = 'RESET_SUMMARY_LOADERS'

export const SUMMARY_CONTEXT_RESET = 'SUMMARY_CONTEXT_RESET'
